<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="120px" @handleConfirm="handleConfirm">
    <!-- 客户名称 -->
    <el-col :span="colSpan">
      <el-form-item :label="$t('billingPage.CustomerName')" prop="cusName">
        <BjSelectLov v-model="form.cusName" :option-list="customerList" @change="changeCustomer" :placeholder="$t('customerNameText')" />
      </el-form-item>
    </el-col>
    <!-- 客户编码 -->
    <!-- <el-col :span="colSpan">
      <el-form-item :label="$t('billingPage.clientCode')" prop="cusCode">
        <BjInput v-model="form.cusCode" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('billingPage.clientCode')" clearable />
      </el-form-item>
    </el-col> -->
    <!-- 选择物流 -->
    <el-col :span="colSpan">
        <el-form-item :label="$t('WarehouseManagement.form.chooseLogistics')" prop="logisticsName">
            <BjSelectLov v-model="form.logisticsName" :option-list="LogisticsSelectionData" :placeholder="$t('inputText')" />
        </el-form-item>
    </el-col>
    <!-- 浮动费率 -->
    <!-- <el-col :span="22">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.DefaultMarkup')" prop="rate">
        <BjInputMoney v-model="form.rate" :maxlength="5" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col> -->
    <el-col :span="colSpan">
      <el-form-item :label="$t('businessLogisticsCompanyBusiness.table.ProfitMargin')" prop="profitMargin">
        <BjInputMoney v-model="form.profitMargin" :placeholder="$t('inputText')" clearable>
          <template slot="append">%</template>
        </BjInputMoney>
      </el-form-item>
    </el-col>
    <!-- 有效期 -->
    <el-col :span="colSpan">
        <el-form-item :label="$t('AccountManagementAdd.from')" prop="queryParamsTime_create">
            <BjDateRangePicker v-model="queryParamsTime_create" :placeholder="$t('AccountManagementAdd.ps2')" />
        </el-form-item>
    </el-col>
  </BjDrawerForm>
</template>
<script>
import { logisticApi } from '@/api';
import BjSelectCustomer from '@/components/BjSelectCustomer/index.vue';
const getDefaultForm = () => {
  return {
    cusName: null,
    // cusCode: null,
    logisticsName: null,
    rate: null,
    startDate: null,
    endDate: null,
  };
};

export default {
  components: {
      BjSelectCustomer,
    },
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      colSpan: 24,
      cusName: null,
      queryParamsTime_create: [],
      LogisticsSelectionData: [],
    };
  },
  computed: {
    // 表单校验
    rules() {
      const validateTime = (rule, value, callback) => {
          this.$nextTick(() => {
            if (!this.form.startDate || !this.form.endDate) {
              callback(new Error(this.$t('chooseText')));
            }
            callback();
          });
        };
      const validateRate = (rule, value, callback) =>{
        if (!value) {
          callback(new Error(this.$t('inputText')));
        }
        if(value<=0 || value>=100){
          callback(new Error(this.$t('businessLogisticsCompanyBusiness.table.errTip')));
        }
        callback();
      }
      const rules = {
        cusName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        logisticsName: [{ required: true, message: this.$t('chooseText'), trigger: 'change' }],
        profitMargin: [{ required: true, validator: validateRate, trigger: 'blur' }],
        queryParamsTime_create: [{ required: true, validator: validateTime, trigger: 'change' }],
      };
      return rules;
    },
    customerList() {
      return this.$store.getters.customerList;
    },
  },
  watch: {
    queryParamsTime_create(v) {
        this.form.startDate = (v || [])[0];
        this.form.endDate = (v || [])[1];
    },
    'form.profitMargin'(val){
      if(val){
        this.form.rate = !isNaN(val) &&  (1/(1-val/100)).toFixed(2)
      }
    }
  },
  created() {
      // 获取物流下拉信息
      this.getDataOfSearch();
  },
  mounted() {},
  methods: {
    getNum(e) {
      this.form.rate = e - 0;
    },
    afterUpload(res) {
      this.form.logo = res;
    },
    show(info) {
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('editText') : this.$t('addText'));
      this.form = Object.assign(getDefaultForm(), info || {});
      this.queryParamsTime_create = this.isEdit ? [info.startDate, info.endDate] : [];
    },

    // 确认按钮执行操作
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }

      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi({...API_DATA, ...{isEnable: 1}});
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    // 客户名称选中后 给后端传cusId参数
    changeCustomer(val, item) {
        console.log(val, item, 'xiangkan ');
        this.form.cusName = item.cusName;
        this.form.cusId = val;
        this.form.cusCode = item.clientCode;
    },
    // 获取物流下拉信息
    async getDataOfSearch() {
      logisticApi.getLogisticsBusiness({...this.queryParams,enableFlag: true,size:999}).then(res => {
        this.LogisticsSelectionData = res.content.filter(item => item.enableFlag).map(item => {
            return {label: item.name,value: item.name};
        });
      })
    },
    // 新增
    addApi(API_DATA) {
      logisticApi.getLogisticRateSave(API_DATA).then(res => {
          if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        }
      );
    },
    // 编辑
    updateApi(API_DATA) {
      logisticApi.getLogisticRateSave(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
            this.$message.success(this.$t('toast.operationSuccessText'));
            setTimeout(() => {
              this.$refs.BjDrawerForm.hide();
              this.reFresh();
            }, 500);
          }
        }
      );
    },
  },
};
</script>
<style scoped>
.el-tag {
  margin: 6px;
}
</style>
